var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImportDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 78
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17844"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1548",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(0 6)",
    fill: "#efecfd"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "check",
    transform: "translate(3 .832)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1548",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(0 .168)",
    fill: "#5f48e9",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31676",
    d: "M33.152 55.695L16.459 42.132l4.746-6.353 10.251 8.329 16.918-25.465 6.348 4.587z",
    fill: "#fff"
  })))));
}

export default SvgImportDone;